module.exports = __webpack_public_path__ + "static/media/slide-img-1.c791a441.png";